export default "__VITE_ASSET__DcZj0cLE__"